/**
 * Quick add on product cards.
 *
 * Contract:
 *   [data-quick-add-url]       — round "+" button on a multi-variant card; value is the product URL (fallback).
 *   [data-quick-add-template]  — <template> next to that button with the pop-up content
 *                                (snippets/quick-add-content.liquid).
 *   #quick-add                 — global <dialog>; [data-quick-add-body] receives the cloned content.
 *   s-product-form[data-stay]  — adds without opening the cart and fires `product-form:added`
 *                                (detail.submitter); data-product-title names the product.
 *   #quick-add-toast           — confirmation toast; [data-quick-add-toast-title] gets the product title.
 */
const dialog = document.getElementById('quick-add');
const body = dialog?.querySelector('[data-quick-add-body]');
const toast = document.getElementById('quick-add-toast');
const toastTitle = toast?.querySelector('[data-quick-add-toast-title]');

let lastTrigger = null;
let toastTimer = null;

function showToast(title) {
  if (!toast) return;
  if (toastTitle) toastTitle.textContent = title || '';
  toast.setAttribute('data-show', '');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.removeAttribute('data-show'), 4000);
}

function markAdded(button) {
  if (!(button instanceof HTMLElement)) return;
  button.setAttribute('data-added', '');
  setTimeout(() => button.removeAttribute('data-added'), 1800);
}

// Open the variant pop-up for multi-variant cards.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('[data-quick-add-url]');
  if (!trigger || !dialog || !body) return;
  event.preventDefault();
  event.stopPropagation();

  const template = trigger.parentElement?.querySelector('template[data-quick-add-template]');
  if (!template) {
    window.location.href = trigger.dataset.quickAddUrl;
    return;
  }

  lastTrigger = trigger;
  body.replaceChildren(template.content.cloneNode(true));
  dialog.showModal();
  const first = body.querySelector('input[name="id"]:checked') || body.querySelector('button[name="add"]');
  first?.focus();
});

// A quick add succeeded: confirm in place.
document.addEventListener('product-form:added', (event) => {
  const form = event.target;
  const title = form?.dataset?.productTitle;

  if (dialog?.open && dialog.contains(form)) {
    const trigger = lastTrigger;
    dialog.close();
    markAdded(trigger);
  } else {
    markAdded(event.detail?.submitter);
  }
  showToast(title);
});

if (dialog) {
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    lastTrigger?.focus?.();
  });
}

// Hide the toast when the cart drawer opens.
const cartDrawer = document.getElementById('cart-drawer');
if (cartDrawer && toast) {
  new MutationObserver(() => {
    if (cartDrawer.hasAttribute('open')) toast.removeAttribute('data-show');
  }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
}
